<div>
    <main lottie [options]="options"></main>
</div>